import BResult from './packages/BResult'

BResult.install = function(Vue) {
    Vue.component(BResult.name, BResult)
}

export default BResult
